export default "__VITE_ASSET__7bf61a99__"